import { $authHost } from "../../http";
import { 
    ROLE_GET_REQUEST, ROLE_GET_SUCCESS, ROLE_GET_ERROR, 
    ROLE_GET_BY_KEY_REQUEST, ROLE_GET_BY_KEY_SUCCESS, ROLE_GET_BY_KEY_ERROR, 
    ROLE_ADD_REQUEST, ROLE_ADD_SUCCESS, ROLE_ADD_ERROR, 
    ROLE_EDIT_REQUEST, ROLE_EDIT_SUCCESS, ROLE_EDIT_ERROR, 
    ROLE_DELETE_REQUEST, ROLE_DELETE_SUCCESS, ROLE_DELETE_ERROR
} from "../constants/roleConstants";

export const getRoles = (args) => async (dispatch) => {
    try {
        dispatch({
            type: ROLE_GET_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        const {data} = await $authHost.post(
            "/api/v1/role/query",
            args || {},
            config,
        );
        dispatch({
            type: ROLE_GET_SUCCESS,
            payload: data.result,
        });
        return data;
    } catch (error) {
        dispatch({
            type: ROLE_GET_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const getRoleByKey = (id) => async (dispatch) => {
    try {
        dispatch({
            type: ROLE_GET_BY_KEY_REQUEST
        });

        const {data} = await $authHost.get(
            `/api/v1/role/${id}`,
        );
        dispatch({
            type: ROLE_GET_BY_KEY_SUCCESS,
            payload: data,
        });
        return data;
    } catch (error) {
        dispatch({
            type: ROLE_GET_BY_KEY_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const addRole = ({ name, code }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: ROLE_ADD_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.post(
            "/api/v1/role",
            { name, code },
            config,
        );
        dispatch(getRoles(queryArgs || {}));
        dispatch({
            type: ROLE_ADD_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: ROLE_ADD_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

/** Гарантирует наличие системных ролей в справочнике (idempotent). */
export const ensureSystemRoles = () => async (dispatch) => {
    const required = [
        { code: "ProvisionSupervisor", name: "Заведующий обеспеченности" },
    ];

    try {
        const { data } = await $authHost.post(
            "/api/v1/role/query",
            { paging: { skip: 0, take: 1000, returnCount: true } },
            { headers: { "Content-Type": "application/json" } }
        );
        const existing = data?.result || [];
        const codes = new Set(existing.map((r) => r.code));

        for (const role of required) {
            if (!codes.has(role.code)) {
                await $authHost.post(
                    "/api/v1/role",
                    role,
                    { headers: { "Content-Type": "application/json" } }
                );
            }
        }

        // обновить стор, чтобы RoleSelect увидел новую роль
        return dispatch(
            getRoles({
                paging: { skip: 0, take: 1000, returnCount: true },
                sort: { name: { operator: "asc" } },
            })
        );
    } catch (e) {
        console.warn("ensureSystemRoles:", e);
        return null;
    }
};

export const editRole = ({ id, name, code }, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: ROLE_EDIT_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.put(
            "/api/v1/role",
            { id, name, code },
            config,
        );
        dispatch(getRoles(queryArgs || {}));
        dispatch({
            type: ROLE_EDIT_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: ROLE_EDIT_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

export const deleteRole = (id, queryArgs) => async (dispatch) => {
    try {
        dispatch({
            type: ROLE_DELETE_REQUEST
        });
        const config = {
            headers: {
                "Content-Type": "application/json",
            },
        };

        await $authHost.delete(
            "/api/v1/role",
            { data: { id } },
            config,
        );
        dispatch(getRoles(queryArgs || {}));
        dispatch({
            type: ROLE_DELETE_SUCCESS,
        });
    } catch (error) {
        dispatch({
            type: ROLE_DELETE_ERROR,
            payload:
                error.response && error.response.data.message
                    ? error.response.data.message
                    : error.message,
        });
    }
};

